/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/Dialog/theme';

export const DialogTheme = theme;
